<template>
  <div class="acmper">
    <!-- 顶部按钮 -->
    <div style="padding: 0 20px;">
      <button
        class="buttons"
        style="background-color: #ee0a24;"
        @click="toBack()"
      >{{returnButtonValue}}</button>
      <van-cell-group
        class="fields"
        style="display: inline-block;width: 40%;margin-left: 10px;"
      >
        <van-field
          style="border-radius:10px;padding: 5px 15px;"
          placeholder="拼音搜索"
          @click="skipSeach()"
        />
      </van-cell-group>
      <button
        v-show="job<3"
        class="buttons"
        style="float:right;color:#000;background-color: #fff;border:1px solid #000;"
        @click="skipGrouping()"
      >调整分组</button>
    </div>
    <!-- /顶部按钮 -->

    <!-- 中队长显示 -->
    <div style="padding:20px 0 0;font-size:15px;font-weight:700">
      <span style="margin-right:10px;">{{info.name}}</span>
      <span>{{info.captain_name||'暂无队长'}}</span>
      <span
        style="margin-left:10px;color:#ee0a24"
        @click="onMobile(info.captain_mobile)"
      >{{info.captain_mobile||'暂无手机号'}}</span>
      <span
        style="margin-left:10px;"
        v-show="info.member_ct"
      >总计 <span style="color:#ee0a24">{{info.member_ct}}人</span></span>
      <span>实到 <span style="color:#ee0a24">{{info.actual_num}}</span>人</span>
    </div>
    <!-- /中队长显示 -->

    <!-- 表 -->
    <div>
      <div
        v-for="(item,index) in List"
        :key="index"
      >
        <!-- 小队长显示 -->
        <div style="font-size:13px;font-weight:700;padding: 15px 10px 8px">
          <span style="margin-right:10px;">{{item.name}}</span>
          <span>{{item.captain_name || '暂无队长'}}</span>
          <span
            style="margin-left:10px;color:#ee0a24"
            @click="onMobile(item.captain_mobile)"
          >{{item.captain_mobile||'暂无手机号'}}</span>
          <span style="margin-left:10px;">总计 <span style="color:#ee0a24">{{item.member_ct}}人</span></span>
          <span>实到 <span style="color:#ee0a24">{{item.actual_num}}</span>人</span>

        </div>
        <!-- /小队长显示 -->
        <div class="gundong">
          <div
            @click="skipPath(item)"
            style="width:100%"
          >
            <van-row>
              <van-col
                span="2"
                class="text-center"
              >序号</van-col>
              <van-col
                span="5"
                class="text-center"
              >姓名</van-col>
              <van-col
                span="2"
                class="text-center"
              >吃药</van-col>
              <van-col
                span="2"
                class="text-center"
              >性别</van-col>
              <van-col
                span="3"
                class="text-center"
              >房间</van-col>

              <van-col
                span="5"
                class="text-center"
              >电话</van-col>
              <van-col
                span="5"
                class="text-center"
              >渠道</van-col>
            </van-row>

            <!-- /表 -->

            <div>
              <div
                v-for="(item2,index2) in item.members"
                :key="index2"
              >
                <van-row
                  type="flex"
                  style="padding:2px 0"
                >
                  <van-col
                    span="2"
                    class="text-center line-h20"
                  >
                    <van-icon
                      v-if="item2.is_birthday"
                      name="point-gift"
                      color="red"
                      size="18"
                      @click.stop="onBirthday(item2.birthday)"
                    />
                    <span v-else>{{index2+1}}</span>
                  </van-col>
                  <van-col
                    span="5"
                    class="text-center line-h20"
                    @click.stop="item2.issue_num>0?onAbnormalSearch(item2):''"
                  >
                    {{item2.real_name}}
                    <van-tag
                      :class="item2.issue_num>0?'':'vhd'"
                      type="danger"
                      round
                    >{{item2.issue_num}}</van-tag>
                  </van-col>
                  <van-col
                    span="2"
                    style="text-align:center;"
                    @click.stop="onTakePills(item2)"
                  >
                    <van-image
                      width="22"
                      height="22"
                      :src="item2.drug_remark?$mAssetsPath.jiaoNang:$mAssetsPath.jiaoNangNo"
                    />
                  </van-col>
                  <van-col
                    span="2"
                    class="text-center line-h20"
                  >{{item2.sex=='man'?'男':'女'}}</van-col>
                  <van-col
                    span="3"
                    class="text-center line-h20"
                  >
                    {{item2.room}}
                  </van-col>

                  <van-col
                    :span="5"
                    class="text-center line-h20"
                    style="color:#ee0a24;"
                  >{{item2.mobile_no||'暂无手机号'}}</van-col>
                  <van-col
                    :span="5"
                    style="font-weight: 700;padding: 2px 0;"
                    class=" line-h20"
                  >{{item2.business_name}}</van-col>
                </van-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 占位 -->
    <div style="height: 40px;width: 100%;"></div>
    <!-- /占位 -->
    <div class="footers">
      <button
        class="buttons cwbf"
        style="width:30%;background-color: aqua;"
        @click="skipPhysicalState()"
      >体温/排便</button>
      <button
        class="buttons cwbf"
        style="width:30%;background-color:gold;margin-left: 5%;"
        @click="takePillsShow=true"
      >吃药</button>

      <button
        class="buttons cwbf"
        style="width:35%;margin-left: 5%;background-color:coral;"
        @click="skipWork()"
      >工作人员</button>
    </div>

    <van-dialog
      v-model="submitChildShow"
      title="吃药备注"
      :show-cancel-button="job <5?true:false"
      @cancel="submitChildShow=false"
      @confirm="submitChildConfirm()"
    >
      <div style="padding:5px;">
        <div style="border: 1px solid #f1f1f1;">
          <van-field
            v-model="submitChildValue"
            type="textarea"
            autosize
            row="5"
            :readonly="job>4?true:false"
            placeholder="请输入药物信息"
          />
        </div>
      </div>
    </van-dialog>

    <!-- 吃药列表 -->

    <van-popup
      v-model="takePillsShow"
      :style="{ width: '85%',height:'80%' }"
      round
      closeable
      :close-on-click-overlay="false"
      @click-close-icon="takePillsShow=false"
    >
      <div style="padding:10px 8px 5px">
        <div style="padding:5px;font-size: 18px;text-align: center;font-weight: 700;">吃药列表</div>
        <div style="padding:10px 15px">
          <div
            v-for="(item,index) in drugsList"
            :key="index"
            style="padding:5px 0;border-bottom: 1px solid #999;"
          >

            <div class="p10-size14">
              <div
                class="title-s"
                style="color:#000;font-weight: 500;vertical-align: top;width: 25%;text-align: left;"
              >{{item.real_name}}</div>
              <div style="display:inline-block;width:74%;word-break: break-all">
                {{item.drug_remark}}
              </div>
            </div>
          </div>
          <div v-if="drugsList.length==0">
            <van-empty description="暂无数据" />
          </div>

        </div>
      </div>
    </van-popup>

    <!-- /吃药列表  -->

    <!-- 生日弹窗 -->
    <van-dialog
      v-model="birthdayShow"
      title="生日"
      :show-cancel-button="false"
      @cancel="birthdayShow=false"
      @confirm="birthdayShow=false"
    >
      <div style="padding:5px;">
        <div style="border: 1px solid #f1f1f1;">
          <van-field
            v-model="birthdayValue"
            type="text"
            input-align="center"
            :readonly="true"
          />
        </div>
      </div>
    </van-dialog>

    <!-- /生日弹窗 -->

  </div>
</template>
<script>
import { delay } from 'q'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      List: [],
      team2_id: '',
      info: {},
      project_id: '', //营期id
      job: '',
      project_info: {},
      returnButtonValue: '',
      team_type: '',
      submitChildIds: '',
      submitChildValue: '',
      submitChildShow: false,
      drugsList: [],
      takePillsShow: false,
      birthdayShow: false,
      birthdayValue: '',
    }
  },
  created() {
    this.project_id = this.$route.query.project_id
    this.team2_id = this.$route.query.team2_id

    this.getListInfo()
  },

  methods: {
    // 生日弹窗
    onBirthday(birthday) {
      this.birthdayValue = birthday
      this.birthdayShow = true
      console.log(birthday, 'birthday')
    },
    //跳转到排便
    skipPhysicalState() {
      this.$router.push({
        path: '/physicalState',
        query: {
          team_id: this.team2_id,
        },
      })
    },
    async getListInfo() {
      this.drugsList = []
      const res = await this.$axios.get('project/teamlist3', {
        params: {
          team2_id: this.team2_id,
        },
      })
      if (res.data.code == 400) {
        this.$router.replace({
          path: '/errorPage',
          query: { msg: res.data.msg },
        })
        return
      }
      if (res.data.code == 201) {
        let team_type = res.data.team_type
        let team_id = res.data.team_id
        switch (team_type) {
          case 3:
            this.$router.push({
              path: '/camper',
              query: {
                project_id: this.project_id,
                team3_id: team_id,
              },
            })
            break
        }

        console.log(res.data, '201返回')
        return
      }

      let data = res.data.data
      this.team_type = data.team_type
      if (this.team_type == 2) {
        this.returnButtonValue = '返回营期'
      } else {
        this.returnButtonValue = '返回全员'
      }
      let teams_data = data.teams_data
      for (let i = 0; i < teams_data.length; i++) {
        for (let j = 0; j < teams_data[i].members.length; j++) {
          if (teams_data[i].members[j].drug_remark) {
            this.drugsList.push(teams_data[i].members[j])
          }
        }
      }
      this.job = data.job

      this.project_info = data.project_info
      this.List = data.teams_data
      this.info = data.team2_info
      console.log()

      let config = {
        title: `【${dayjs(this.project_info.date_start).format(
          'YYYY-MM-DD'
        )}】${this.project_info.party_title}`,
        img: 'https://img.jiarixiaodui.com/jrhb-logo.jpg',
        sharePath: `/lochus?project_id=${this.project_id}&team2_id=${this.team2_id}`,
      }
      console.log(config, 'config')
      this.wxShare(config)
    },
    skipPath(item) {
      console.log(item)
      this.$router.push({
        path: '/camper',
        query: {
          team3_id: item.id,
          project_id: this.project_id,
        },
      })
    },
    skipSeach() {
      this.$router.push({
        path: '/posSeach',
        query: {
          project_id: this.project_id,
        },
      })
    },
    skipGrouping() {
      this.$router.push({
        path: '/grouping',
        query: {
          project_id: this.project_id,
          team2_id: this.team2_id,
        },
      })
    },
    skipWork() {
      this.$router.push({
        path: '/work',
        query: {
          project_id: this.project_id,
        },
      })
    },
    onMobile(phoneNumber) {
      console.log(phoneNumber, '手机号')
      if (phoneNumber) {
        window.location.href = 'tel://' + phoneNumber
      }
    },
    toBack() {
      if (this.team_type == 2) {
        this.$router.push({
          path: '/Position',
        })
      } else {
        this.$router.push({
          path: '/posDetail',
          query: {
            project_id: this.project_id,
          },
        })
      }
    },
    onAbnormalSearch(item) {
      this.$router.push({
        path: '/abnormalSearch',
        query: {
          project_id: this.project_id,
          seachValue: item.real_name,
        },
      })
    },
    //吃药
    onTakePills(item) {
      this.submitChildIds = item.id
      this.submitChildValue = item.drug_remark
      this.submitChildShow = true
    },
    submitChildConfirm() {
      if (this.job > 4) {
        this.submitChildShow = false
        return
      }
      this.$axios
        .post('/project/update-remark', {
          id: this.submitChildIds,
          type: 'drug',
          remark: this.submitChildValue,
        })
        .then((res) => {
          this.$toast(res.data.msg)
          this.submitChildShow = false
          this.getListInfo()
          console.log(res, 'res')
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.acmper {
  padding: 20px 0 60px;
  height: 100%;
}

.text-center {
  text-align: center;
  font-weight: 700;
  // padding: 5px 0;
}

.line-h20 {
  line-height: 23px;
}
.buttons {
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
}
.footers {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  display: flex;
  // justify-content: space-between;
  font-size: 13px;
  font-weight: 700;
  background-color: #fff;
}
.fields {
  display: inline-block;
  width: 40%;
  margin-left: 10px;
  border: 0.5px solid dodgerblue;
  border-radius: 5px;
}
.cwbf {
  color: #000;
  border: 1px solid #000;
}
.vhd {
  visibility: hidden;
}
.gundong {
  border-bottom: 1px solid #f7f7f7;
  max-width: 100%;
  margin: auto;
  overflow-x: auto;
  white-space: nowrap;
  overflow-y: hidden;
}
.gundong::-webkit-scrollbar {
  display: none;
}
.p10-size14 {
  padding: 5px 10px;
  font-size: 14px;

  .title-s {
    display: inline-block;
    width: 35%;
    font-weight: 500;
    color: brown;
    text-align: center;
  }

  .value-s {
    display: inline-block;
    color: deepskyblue;
  }
}
</style>